const ENTRY_POINT_PATH = {
  DASHBOARD_PAGE: 'DashboardPage',
  DASHBOARD_OVERVIEW_PAGE: 'DashboardOverviewPage',
  EDIT_LISTING_PAGE: 'EditListingPage',
  MODULAR_LISTING: 'ModularListing',
  POST_LISTING_ACTIVATION_SOFT_UPSELL: 'PostListingActivationSoftUpsell',
  POST_LISTING_ACTIVATION_HARD_UPSELL: 'PostListingActivationHardUpsell',
  PROPERTY_DETAILS: 'PropertyDetails',
  APPLICATIONS_OPT_IN_UPSELL: 'ApplicationsOptInUpsell',
};

const RP_STATE_FOR_LISTING = {
  ACTIVE: 'active',
  // eslint-disable-next-line constellation/word-list
  CANCELLED: 'cancelled',
  NOT_ENROLLED: 'notEnrolled',
  PENDING: 'pending',
  PENDING_CANCELLATION: 'pendingCancellation',
};

const PRODUCT_INTRO_TYPES = {
  MODULAR_LISTING: 'modularListing',
  SOH_ILLUSTRATIVE: 'sohIllustrative',
  POST_ACTIVATION_ILLUSTRATIVE: 'postActivationIllustrative',
};

const RENTAL_PROTECTION_DETAILS_COVERAGE_LINK =
  'https://wp-tid.zillowstatic.com/1/Rental-Protection-Coverage-Summary-FINAL-April-2022-c864d0.pdf';

const LIGHTWEIGHT_TEST_OPT_IN = {
  DEFAULT_COVERAGE_AMOUNT: '$5,000',
  DEFAULT_PREMIUM_AMOUNT: '$45',
};

export {
  ENTRY_POINT_PATH,
  RENTAL_PROTECTION_DETAILS_COVERAGE_LINK,
  RP_STATE_FOR_LISTING,
  PRODUCT_INTRO_TYPES,
  LIGHTWEIGHT_TEST_OPT_IN,
};
